// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

//import styles
import '../../assets/styles/containerStyles/page-add-edit.scss';
import '../../assets/styles/components/medias-list-wrapper.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {MediaFileCard} from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import {GetAboutData, UpdateAboutData} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {ACCEPT_IMAGE_TYPES} from "../../constants/acceptedTypes";
import {MEDIA_MODAL_TYPES} from "../../constants/constTypes";
import Nestable from "react-nestable";
import {Editor} from "../../components/uiElements/Editor";

class About extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                medias: [],
            },
            isEditing: true,
            errors: {},
            errorsTabs: [],
            languageTab: props.mainLanguage,
            mediaModalType: null,
            requestLoading: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.toggleMediaModal = changeStateField.bind(this, 'mediaModalType');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);

        this.checkMediaListDifferent = this.checkMediaListDifferent.bind(this);
        this.onMediaPositionChange = this.onMediaPositionChange.bind(this);
        this.mediaCardWrapper = this.mediaCardWrapper.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.addEditAbout = this.addEditAbout.bind(this);
    }

    async componentDidMount() {
        await this.props.GetAboutData(this.props.id)
        const {aboutData} = this.props;
        const {fieldsData} = this.state;

        const translationsData = {};
        const editingData = aboutData
        if (editingData) {
            Object.keys(fieldsData.translations).forEach(key => {
                const trItem = editingData?.translations?.find(item => item.language === key);
                translationsData[key] = {
                    ...fieldsData.translations[key],
                    title: trItem?.title || '',
                    description: trItem?.description || '',
                };
            });
        }
        const initStateData = {
            translations: translationsData,
            mediaMain: editingData?.mediaMain,
            medias: editingData?.medias || [],
        }
        this.currentData = JSON.parse(JSON.stringify(initStateData));
        this.setState({
            fieldsData: initStateData,
        });

    }

    getMedia(mediaArray, mediaType) {
        const {fieldsData, errors, isEditing, mediaModalType} = this.state;
        if (isEditing) {
            if (mediaType === MEDIA_MODAL_TYPES.MEDIA_MAIN) {
                this.currentData?.[mediaModalType]?.id !== mediaArray[0]?.id
                    ? this.updatedDataMap.set(mediaModalType, mediaArray[0]?.id)
                    : this.updatedDataMap.delete(mediaModalType);
            } else {
                this.checkMediaListDifferent(mediaArray)
            }

        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [mediaModalType]: mediaType === MEDIA_MODAL_TYPES.MEDIA_MAIN
                    ? mediaArray[0] : mediaArray,
            },
            errors: {
                ...errors,
                [mediaModalType]: false
            }
        })
    }

    deleteMedia(type, id) {
        const {fieldsData, isEditing} = this.state;
        let medias = fieldsData.medias.filter(m => m.id !== id);

        if (isEditing) {
            if (type === 'medias') {
                this.checkMediaListDifferent(medias)
            } else {
                this.currentData?.[type] ?
                    this.updatedDataMap.set(type, null) :
                    this.updatedDataMap.delete(type);
            }

        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: type === 'medias' ? medias : null
            }
        })
    }

    checkMediaListDifferent(currMedias) {
        let result = false;
        const initMedias = this.currentData.medias;
        if (!Array.isArray(currMedias) || (currMedias?.length !== initMedias.length)) {
            result = true;
        } else {
            currMedias.forEach((item, index) => {
                if (initMedias[index]?.id !== item?.id) {
                    result = true;
                }
            })
        }
        result ? this.updatedDataMap.set('medias', currMedias?.map(m => m.id))
            : this.updatedDataMap.delete('medias');
    }

    onMediaPositionChange(items) {
        const {fieldsData, isEditing} = this.state;
        const medias = items.map(item => item.media);
        if (isEditing) {
            // this.checkMediaListDifferent(medias)
            this.updatedDataMap.set('medias', medias?.map(m => m.id))
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                medias: medias
            }
        })
    }

    mediaCardWrapper(data) {
        return <MediaFileCard item={data?.item?.media}
                              customDelete={this.deleteMedia.bind(this, 'medias', data?.item?.media?.id)}/>
    }

    async addEditAbout() {
        await this.setState({
            requestLoading: true
        });
        const {translations, mediaMain} = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = {...validationTr.errors};
        // medias?.length
        if (!mediaMain) {
            errors.mediaMain = true;
            result = false;
        }

        if (result) {
            const trData = getTranslationData(translations);
            const reqData = this.getPatchReqData(trData);

            this.props.UpdateAboutData(reqData)
                .finally(() => {
                    this.setState({
                        requestLoading: false,
                        errors: {},
                        errorsTabs: [],
                    });
                });

        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render() {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalType,
            requestLoading,
            errorsTabs
        } = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        const mediaItems = [];
        fieldsData.medias.forEach(media => {
            mediaItems.push({
                id: media?.id,
                media: media
            })
        });

        return <PageWrapper pageTitle={'Մեր մասին'}>
            <section className="page-add-edit about">
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար {/*<span className={'required-badge'}>*</span>*/}</label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'mediaMain')}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}
                                           customDelete={() => this.deleteMedia("mediaMain")}
                            />
                        </div>}
                    </div>
                </div>
                <div className={'medias-list-wrapper'}>
                    <div className={'label-and-action'}>
                        <label>Նկարներ</label>
                        <LinkButton title="Ընտրել Մեդիադարանից"
                                    className={`media-select-btn `}
                                    cb={this.toggleMediaModal.bind(this, 'medias')}/>
                    </div>
                    <section className={'items-wrapper'}>
                        {mediaItems.length ? <Nestable
                                items={mediaItems}
                                maxDepth={1}
                                onChange={this.onMediaPositionChange}
                                renderItem={this.mediaCardWrapper}
                            /> :
                            <p className={'empty-text'}>Նկարներ չկան</p>}
                    </section>
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <div>
                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <div className="editor-wrapper">
                        <label>Նկարագրություն</label>
                        <Editor value={currentData?.description || ''}
                                name={'description'}
                                required={true}
                                initValue={initData?.description}
                                error={errors['description' + languageTab]}
                                onChange={this.getTranslationValues}/>
                    </div>
                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={'Փոփոխել'}
                                loading={requestLoading}
                                disabled={!this.updatedDataMap.size}
                                cb={this.addEditAbout}/>
                </div>

            </section>

            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                mediaType={mediaModalType === "medias" ? MEDIA_MODAL_TYPES.MEDIA_ARRAY : MEDIA_MODAL_TYPES.MEDIA_MAIN}
                appendMedias={mediaModalType === "medias" && fieldsData.medias}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetAboutData,
    UpdateAboutData,
};

export default connect(mapStateToProps, mapDispatchToProps)(About)
